import { Button } from '@mui/material';
import { ASSETS } from '../../const/assets';
import { IAiModel } from '../../api/chat';

interface EmptyChatProps {
  aiModelCurrent: IAiModel | null;
  defaultModel: IAiModel | undefined;
  handleOpenModelDialog: () => void;
}

function EmptyChat({
  aiModelCurrent,
  defaultModel,
  handleOpenModelDialog,
}: EmptyChatProps) {
  return (
    <div className="flex items-center justify-center flex-col">
      <img src={ASSETS.icLogo} alt="icLogo" className="w-20 h-20" />
      <span className="text-[32px] font-medium mt-8 text-center">
        How can I help you today!
      </span>
      <div className="flex items-center gap-8 mt-8 flex-col md:flex-row">
        <span className="text-base font-medium">Powered by</span>
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-2">
            <img
              src={
                aiModelCurrent?.aiModelProvider.image ||
                defaultModel?.aiModelProvider.image
              }
              alt="icAi"
              className="w-10 h-10"
            />
            <span className="text-base font-bold">
              {aiModelCurrent?.name || defaultModel?.name}
            </span>
          </div>

          <Button
            onClick={handleOpenModelDialog}
            variant="contained"
            sx={{
              borderRadius: '10px',
              backgroundColor: 'black',
              color: 'white',
              height: '28px',
              fontSize: '14px',
              fontWeight: 'medium',
              textTransform: 'none',
            }}
          >
            Change
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EmptyChat;
